import * as React from 'react';
import { AddDocumentItemOptions } from 'app/infrastructure/ui/form/types';
import get from 'lodash/get';

/**
 * Inserts a field using the  @param`fieldName` as key, with the object returned 
 * from @param`valuePropertyPath` as the fields value when onAddDocumentItem is called.
 * 
 * This supports the pattern where rows are filtered based on their category.
 */
export const withRowFieldInitialValue = (fieldName: string, valuePropertyPath: string) => <P extends { 
  onAddDocumentItem: (selectAddedItem?: boolean, options?: AddDocumentItemOptions) => void 
}>(
  WrappedComponent: React.ComponentClass<P>
): React.ComponentClass<P> => {
  return class extends React.Component<P> {
    private onAddDocumentItem = (selectAddedItem?: boolean, options: AddDocumentItemOptions = {}) => {
      const value = get(this.props, valuePropertyPath);

      const initialValues = fieldName && value && { 
        ...(options && options.initialValues),
        [fieldName]: [{ value }]
      };

      this.props.onAddDocumentItem(selectAddedItem, {
          ...options, 
          initialValues: initialValues || options.initialValues
        });
    }

    public render() {
      return <WrappedComponent {...this.props} {...{onAddDocumentItem: this.onAddDocumentItem}} />;
    }
  };
};
